const passwordPattern = {
  pattern: /^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]{6,16}$/,
  message: "\u8BF7\u8F93\u51656-16\u4F4D\u7684\u82F1\u6587\u5B57\u6BCD\u3001\u6570\u5B57\u3001\u7279\u6B8A\u5B57\u7B26\u7EC4\u5408"
};
const verificationPattern = {
  pattern: /^\d{6}$/,
  message: "\u8BF7\u8F93\u51656\u4F4D\u7684\u6570\u5B57\u9A8C\u8BC1\u7801"
};
export {
  passwordPattern,
  verificationPattern
};
